import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { SERVICES } from '../lib/site';

const ServicesGrid = () => {
  return (
    <section id="servicios" className="py-24 md:py-32 max-w-[1400px] mx-auto px-6">
      <div className="flex flex-wrap items-end justify-between gap-6 mb-14 reveal">
        <div>
          <p className="label">Qué hacemos</p>
          <h2 className="font-display font-black uppercase tracking-[-0.02em] text-section-title mt-5">
            Servicios de <em className="font-serifit normal-case font-normal text-clay">construcción</em>
            <br />
            y reformas
          </h2>
        </div>
        <p className="max-w-sm text-ink-soft leading-relaxed text-[0.95rem]">
          Del plano a las llaves: ejecutamos tu proyecto completo con equipos propios,
          certificados y en plazo. <Link to="/presupuesto" className="link-underline font-semibold text-ink">Solicita presupuesto</Link> — es gratis.
        </p>
      </div>

      {/* Lista editorial con números — no tarjetas genéricas */}
      <div className="border-t border-line">
        {SERVICES.map((service, i) => (
          <Link
            key={service.slug}
            to={`/servicios/${service.slug}`}
            className="reveal group grid grid-cols-[auto_1fr_auto] md:grid-cols-[64px_1fr_auto_64px] items-center gap-5 md:gap-10 py-7 md:py-8 border-b border-line"
          >
            <span className="section-index hidden md:block">{service.index}</span>
            <div>
              <h3 className="font-display font-bold uppercase tracking-[-0.01em] text-[clamp(1.35rem,3vw,2.1rem)] leading-none group-hover:text-clay transition-colors duration-200">
                {service.title}
              </h3>
              <p className="mt-2.5 text-ink-soft text-[0.92rem] leading-relaxed max-w-[60ch]">{service.short}</p>
            </div>
            <span className="hidden md:inline text-[0.68rem] font-bold uppercase tracking-[0.2em] text-ink-faint group-hover:text-clay transition-colors duration-200">
              Saber más
            </span>
            <span className="grid place-items-center w-11 h-11 md:w-12 md:h-12 rounded-full border border-line group-hover:bg-ink group-hover:border-ink group-hover:text-paper transition-all duration-[250ms]" style={{ transitionTimingFunction: 'cubic-bezier(0.23,1,0.32,1)' }}>
              <ArrowUpRight size={20} className="transition-transform duration-[250ms] group-hover:rotate-45" style={{ transitionTimingFunction: 'cubic-bezier(0.23,1,0.32,1)' }} />
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default ServicesGrid;
